import React from "react";
import { FileSearch, Zap, AlertTriangle, ArrowRight } from "lucide-react";

const OUTCOMES = [
  {
    icon: FileSearch,
    text: "A quick review of your current workflow or documentation use case.",
  },
  {
    icon: Zap,
    text: "A high-level read on AI fit for that workflow.",
  },
  {
    icon: AlertTriangle,
    text: "Initial flags around review, oversight, traceability, or evidence gaps.",
  },
  {
    icon: ArrowRight,
    text: "Practical next-step recommendations for safer implementation.",
  },
];

export default function ValidationWhatYouGet() {
  return (
    <section className="py-14 sm:py-16 bg-background border-b border-border">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl sm:text-3xl font-bold text-foreground tracking-tight mb-4">
          What you get in the free assessment
        </h2>
        <p className="text-base text-muted-foreground leading-relaxed mb-8 max-w-2xl">
          This assessment is designed to give your lab a practical starting point, not a vague AI score. You describe your current workflow, and LabComplyx returns a structured view of likely risk points, likely AI-fit areas, and what controls should be considered before moving forward.
        </p>
        <div className="grid sm:grid-cols-2 gap-4">
          {OUTCOMES.map((o) => (
            <div key={o.text} className="flex items-start gap-4 bg-card border border-border rounded-xl p-5">
              <div className="w-8 h-8 rounded-lg bg-primary/5 flex items-center justify-center shrink-0">
                <o.icon className="w-4 h-4 text-primary" />
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed">{o.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}